import React from 'react';
import { View, Image } from 'react-native-web';

import './LogoHeader.module.scss';

const headerImage = require('../../../images/styleseat-logo-black.png');

/**
 * Renders a `header` element containing a centered StyleSeat logo with margins above and below
 */
const LogoHeader = () => (
  <View accessibilityRole="banner" styleName="headerArea">
    <Image
      styleName="headerIcon"
      source={headerImage}
    />
  </View>
);

export default LogoHeader;
